<template>
  <div class="container-fluid">
    <route-header>
      <h3>{{ $t('labels.nav.vehicles') }}</h3>
      <div class="d-flex align-items-center">
        <bs-button v-if="auth.can['edit_vehicles']" class="btn-sm btn-info" @click="$refs.vehicles.create()">{{ $t('labels.action_vehicle',  { action: $t('labels.create') }) }}</bs-button>
      </div>
    </route-header>
    <div class="row">
      <div class="col-12">
        <vehicles ref="vehicles" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'VehicleList',
  computed: {
    ...mapState({
      auth: state => state.auth
    })
  }
}
</script>
